import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wealthos_token');
  const clientId = localStorage.getItem('wealthos_client_id');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (clientId) config.headers['X-Client-ID'] = clientId;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('wealthos_token');
      localStorage.removeItem('wealthos_client_id');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
export { API_BASE, BACKEND_URL };
